import { PropsWithChildren } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { IThemeContext } from './types';

export function UIProvider({
  children,
  themeResolver,
}: { themeResolver: () => Promise<IThemeContext> } & PropsWithChildren) {
  return <ThemeProvider themeResolver={themeResolver}>{children}</ThemeProvider>;
}
